import { createContext, useState, useEffect } from 'react';

const EMPTY_AUTH = { userInfo: null, userRole: null };

const AuthContext = createContext({ auth: EMPTY_AUTH, setAuth: () => {} });

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        const storedUserInfo = localStorage.getItem('userInfo');
        return storedUserInfo
            ? { ...EMPTY_AUTH, userInfo: JSON.parse(storedUserInfo) }
            : EMPTY_AUTH;
    });

    useEffect(() => {
        if (auth.userInfo) {
            localStorage.setItem('userInfo', JSON.stringify(auth.userInfo));
        } else {
            localStorage.removeItem('userInfo');
        }
    }, [auth.userInfo]);

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
